import { Button, Flex } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

export function FormDebug() {
  const { formState, getValues } = useFormContext();
  const { errors } = formState;

  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      console.log('<Form /> errors:', errors);
    }
  }, [errors]);

  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  return (
    <Flex gap={2} bg="snap.yellow.600/20" p={2} rounded="lg" mb={4}>
      <Button
        variant="outline"
        colorScheme="orange"
        size="xs"
        onClick={() => console.log('values', getValues())}
      >
        Log Form Values
      </Button>

      <Button
        variant="outline"
        colorScheme="orange"
        size="xs"
        onClick={() => console.log('errors', errors)}
      >
        Log Form Errors
      </Button>

      <Button
        variant="outline"
        colorScheme="orange"
        size="xs"
        onClick={() => console.log('formState', formState.dirtyFields)}
      >
        Log Dirty Fields
      </Button>

      <Button
        variant="outline"
        colorScheme="orange"
        size="xs"
        onClick={() => console.log('formState', formState)}
      >
        Log Form State
      </Button>
    </Flex>
  );
}
